<template>
	<div>
		<el-dialog :title="$t('DataRecycling.ViewChartDisplaySettings')" v-if="dialogVisible" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
			<div>
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
					<el-tab-pane :label="$t('DataRecycling.DisplayByTitle')" name="1">
						<div style="padding:0px 20px;">
							<el-table ref="multipleTable" :data="topicData" border style="width: 100%" @selection-change="topicSelectionChange">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column prop="questionsName" :label="$t('DataRecycling.Topic')"></el-table-column>
							</el-table>
						</div>
					</el-tab-pane>
					<el-tab-pane :label="$t('DataRecycling.DisplayAccordingToQuestionType')" name="2">
						<el-tree
							node-key="questionsTypeId"
							ref="tree"
							:default-checked-keys="checkedKeys"
							:props="props"
							:data="questionTypesList"
							show-checkbox
							@check-change="handleCheckChange"
						></el-tree>
					</el-tab-pane>
				</el-tabs>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="chartDisplaySettingsOk">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			topicSelection: [],
			topicData: [],
			surveyId: '',
			activeName: '1',
			dialogVisible: false,
			props: {
				label: 'questionsName',
				children: 'children'
			},
			questionTypesList: [],
			questionTypesSelection: [],
			checkedKeys: []
		};
	},
	methods: {
		chartDisplaySettingsOk() {
			let ids = [];
			let types = [];
			if (this.activeName == 1) {
				if (this.topicSelection.length == 0) {
					ids = [];
					// this.$message.warning('请选择展示的题目');
					// return false;
				} else {
					this.topicSelection.forEach(item => {
						ids.push(item.qid);
					});
				}
				types = [];
			} else {
				let arr = this.$refs.tree.getCheckedKeys();
				let newArr = arr.filter(function(item, index) {
					return arr.indexOf(item) === index; // 因为indexOf 只能查找到第一个
				});
				if (newArr.length == 0) {
					// this.$message.warning('请选择展示的题型');
					// return false;
					types = [];
				} else {
					types = newArr;
				}
				ids = [];
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.addExportConf}`,
				method: 'POST',
				data: {
					surveyId: this.surveyId,
					ids: ids.toString(),
					types: types.toString()
				},
				cb(res) {
					if (res.code == 0) {
						that.$emit('chartDisplaySettingsOK');
						that.activeName = '1';
						that.dialogVisible = false;
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},

		handleCheckChange(data, checked, indeterminate) {
			console.log(data, checked, indeterminate);
		},

		unique(data, key) {
			let lastData = [];

			data.forEach(item => {
				let status = lastData.some(value => value[key] == item[key]);
				if (!status) {
					let obj = {
						questionsName: this.questionTypesName(item.questionsTypeId),
						questionsTypeId: item.questionsTypeId,
						children: []
					};
					obj.children.push(item);
					lastData.push(obj);
				} else {
					lastData.forEach((value, index) => {
						if (value[key] === item[key]) {
							value.children.push(item);
						}
					});
				}
			});
			return lastData;
		},

		topicSelectionChange(val) {
			this.topicSelection = val;
		},
		htmlToString(htmlStr) {
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g, '');
		},
		queryAllQuestionnaire() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionlist}?id=${this.surveyId}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						let topicData = JSON.parse(res.resultBody.tbExamPaper.paperjson).questionsList;
						topicData.forEach((item, index) => {
							console.log(item);
							item.questionsName = that.htmlToString(item.questionsName);
							if (item.questionsTypeId == '26') {
								topicData.splice(index, 1);
							}
						});
						that.topicData = topicData;
						console.log('that.topicData :>> ', that.topicData);

						let questionTypesList = that.unique(that.topicData, 'questionsTypeId');
						that.questionTypesList = questionTypesList;
						that.loadData();
					} else {
						that.topicData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleClick(tab, event) {},
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportConf}?id=${this.surveyId}`,
				method: 'Get',
				data: {},
				cb(res) {
					if (res.code == 0) {
						console.log(11111, res);
						if (res.resultBody != '') {
							if (res.resultBody.ids != '') {
								console.log('11111111111', res.resultBody.ids);
								that.topicSelection = res.resultBody.ids.split(',');
								that.activeName = '1';
								let topicSelection = JSON.parse(JSON.stringify(that.topicSelection));
								that.topicData.forEach(item => {
									topicSelection.forEach(itmeid => {
										if (item.qid == itmeid) {
											that.$refs.multipleTable.toggleRowSelection(item);
										}
									});
								});
							} else if (res.resultBody.types != '') {
								that.checkedKeys = res.resultBody.types.split(',');
								that.activeName = '2';
							} else {
								that.activeName = '1';
							}
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		openSetShowGraph() {
			this.surveyId = sessionStorage.getItem('wid');
			this.topicData = [];
			this.questionTypesList = [];

			this.queryAllQuestionnaire();
			this.dialogVisible = true;
		},
		questionTypesName(id) {
			console.log(id);
			switch (id) {
				case '1':
					return this.$t('DataRecycling.InputTypeQuestion');
					break;
				case '10':
					return this.$t('DataRecycling.MultipleChoiceQuestions');
					break;
				case '11':
					return this.$t('DataRecycling.StarRating');
					break;
				case '12':
					return this.$t('DataRecycling.TrueOrFalse');
					break;
				case '13':
					return this.$t('DataRecycling.DateSelection');
					break;
				case '14':
					return this.$t('DataRecycling.SortQuestion');
					break;
				case '15':
					return this.$t('DataRecycling.AddressLocation');
					break;
				case '16':
					return this.$t('DataRecycling.CitySelection');
					break;
				case '17':
					return this.$t('DataRecycling.Timing');
					break;
				case '18':
					return this.$t('DataRecycling.MatrixTypeQuestions');
					break;
				case '19':
					return this.$t('DataRecycling.MatrixRadioSelection');
					break;
				case '2':
					return this.$t('DataRecycling.CellPhoneNumber');
					break;
				case '20':
					return this.$t('DataRecycling.MatrixMultipleSelection');
					break;
				case '21':
					return this.$t('DataRecycling.MatrixStarRating');
					break;
				case '22':
					return this.$t('DataRecycling.MatrixFillingInTheBlank');
					break;
				case '23':
					return this.$t('DataRecycling.FillInTheBlankWithMultipleRowsOfMatrix');
					break;
				case '24':
					return this.$t('DataRecycling.MoreQuestionTypes');
					break;
				case '25':
					return this.$t('DataRecycling.Headings');
					break;
				case '26':
					return this.$t('DataRecycling.Paging');
					break;
				case '27':
					return this.$t('DataRecycling.PersonalInformation');
					break;
				case '28':
					return this.$t('DataRecycling.FullName');
					break;
				case '29':
					return this.$t('DataRecycling.Gender');
					break;
				case '3':
					return this.$t('DataRecycling.SingleLineInputBox');
					break;
				case '30':
					return this.$t('DataRecycling.Age');
					break;
				case '31':
					return this.$t('DataRecycling.Career');
					break;
				case '32':
					return this.$t('DataRecycling.Mailbox');
					break;
				case '33':
					return this.$t('DataRecycling.UploadFiles');
					break;
				case '34':
					return this.$t('DataRecycling.FillInTheBlankHorizontally');
					break;
				case '35':
					return this.$t('DataRecycling.MultipleBlankFilling');
					break;
				case '36':
					return this.$t('DataRecycling.CascadeQuestions');
					break;
				case '37':
					return this.$t('DataRecycling.SpecificGravityQuestion');
					break;
				case '38':
					return this.$t('DataRecycling.ScaleQuestions');
					break;
				case '4':
					return this.$t('DataRecycling.MultilineInputBox');
					break;
				case '5':
					return this.$t('DataRecycling.FillInTheBlanks');
					break;
				case '6':
					return this.$t('DataRecycling.PictureSelection');
					break;
				case '7':
					return this.$t('DataRecycling.MultipleChoiceQuestions');
					break;
				case '8':
					return this.$t('DataRecycling.MultipleChoice');
					break;
				case '9':
					return this.$t('DataRecycling.DropDownList');
					break;
				case '39':
					return this.$t('DataRecycling.MatrixCombination');
					break;
			}
		}
	}
};
</script>

<style></style>
